import Account from './components/Account';

function App() {
	return (
		<div className='App'>
			<Account />
		</div>
	);
}

export default App;
